
import * as ipxRuntime$_1D58N0rfW41aciK9pSxchj23S_45sq_dd71GBFdxXZXp4 from '/agent/_work/2/s/front/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as bunnyRuntime$oF5UxnKsMIlWP2cU5e3dEJEQIFnSENWsTHdAUDq_W8k from '/agent/_work/2/s/front/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/bunny'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "bunny",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_1D58N0rfW41aciK9pSxchj23S_45sq_dd71GBFdxXZXp4, defaults: {} },
  ['bunny']: { provider: bunnyRuntime$oF5UxnKsMIlWP2cU5e3dEJEQIFnSENWsTHdAUDq_W8k, defaults: {} }
}
        